module.exports = "/src/views/player/help/images/mws.jpg";